// 基础数据接口地址
import request from "@/utils/request"

// 器械包列表
export const getPackageOptions = function(query) {
  return request('post', '/api/common/instrumentset', query)
}

// 人员列表
export const getUserOptions = function(type = 0, query = {}) {
  const url = `/api/common/getUser/${type}`
  
  return request('get', url, query)
}

// 科室列表
export const getDepartmentOptions = function(query) {
  return request('get', '/api/common/department', query)
}

// 设备选项（灭菌器、清洗机）
export const getEquipments = function(query) {
  return request('get', '/api/common/equipment', query)
}

// 计算灭菌失效时间
export const getSterilizeDeadline = function(query) {
  return request('get', '/api/common/getSterilizationDeadlineDate', query)
}

// 获取器械明细
export const getPackageDetail = function(id, ) {
  const url = `/api/common/instrumentset/${id}`
  
  return request('get', url)
}

// 获取租户最后一次打印数据
export const getLastPrint = function(query) {
  return request('get', '/api/common/getLastPrint',query)
}